export default "/static/media/consultant.b16be58404a5b14482bbe4e8a6b3509d.svg";